<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="14" view-id="10014" approve-type="6" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="14" :data="data">
					<!--状态-->
					<template #status>
						<c-state dict="flowOrderStateDic" :value="data.status"></c-state>
					</template>

					<!--紧急程度-->
					<template #emergency_level>
						<c-state dict="orderUrgencyDic" :value="data.emergency_level"></c-state>
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_overtime_application',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/affairs/overtime/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>